import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import defaultsDeep from 'lodash/defaultsDeep';

import reducers from '../reducers';
import api from '../middleware/api';
import prismic from '../middleware/prismic';
import storyblok from '../middleware/storyblok';
import tracking from '../middleware/analytics';

export default function storeProvider(initialState = {}, isServer) {
  if (!isServer && typeof window !== 'undefined' && window.store) {
    return window.store;
  }

  const mergedState = defaultsDeep({}, initialState, reducers());
  const composedMiddleware = composeWithDevTools(
    applyMiddleware(tracking, api, thunk, prismic, storyblok),
  );
  const store = createStore(reducers, mergedState, composedMiddleware);

  if (typeof window !== 'undefined') {
    if (module.hot) {
      module.hot.accept('../reducers', () => {
        // eslint-disable-next-line
        const nextReducer = require('../reducers');
        store.replaceReducer(nextReducer);
      });
    }
    window.store = store;
  }

  return store;
}
